<template>
  <div class="itinerario-wrapper">
    <div class="rasgado rasgado-superior"></div>

    <section class="itinerario-section">
      <div class="timeline-container">
        <h2 class="timeline-title">
          Itinerario
          <span class="sub">
            Agradecemos tu puntualidad. <br />
          </span>
        </h2>

        <div class="timeline">
          <div
            v-for="evento in eventos"
            :key="evento.nombre"
            :ref="el => eventoRefs.push(el)"
            class="timeline-item"
          >
            <div class="timeline-line" />
            <div class="timeline-icon-wrapper">
              <div class="timeline-star">★</div>
              <div class="timeline-icon-circle">
                <img :src="evento.icono" :alt="evento.nombre" class="timeline-icon" />
              </div>
            </div>

            <div class="timeline-time">
              <p class="evento">{{ evento.nombre }}</p>
              <p>{{ evento.hora }}</p>
              <p v-if="evento.nota" class="nota">{{ evento.nota }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'ItinerarioComponent',
  setup() {
    const eventos = [
      {
        nombre: 'Bendición ',
        hora: '12:00 PM',
        icono: require('@/assets/iglesia-itinerario1.gif'),
      },
      {
        nombre: 'Comida',
        hora: '5:00 - 7:00 PM',
        icono: require('@/assets/cena_time.png'),
      },
      
           {
        nombre: 'Baile',
        hora: '7:00 - 12:00 PM',
        icono: require('@/assets/fiesta_time.png'),
      },
      
    ];

    const eventoRefs = ref([]);

    onMounted(() => {
      eventoRefs.value.forEach((el) => {
        if (!el) return;

        const icon = el.querySelector('.timeline-icon');
        const star = el.querySelector('.timeline-star');
        const time = el.querySelector('.timeline-time');

        gsap.set([icon, star, time], { opacity: 0, y: 50 });

        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                gsap.to(icon, { opacity: 1, y: 0, delay: 0.1, duration: 1, ease: 'power2.out' });
                gsap.to(star, { opacity: 1, scale: 1, delay: 0.3, duration: 1, ease: 'back.out(1.7)' });
                gsap.to(time, { opacity: 1, y: 0, delay: 0.5, duration: 1, ease: 'power2.out' });
                obs.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.3 }
        );

        observer.observe(el);
      });
    });

    return { eventos, eventoRefs };
  }
};
</script>

<style scoped>
.itinerario-section {
  padding: 40px 20px;
 background-image:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.041),
      rgba(0,0,0,0.15)
    ),
    url('@/assets/madera.jpg');  background-size: cover;
  background-position: center;
  margin-top: -20px;
  margin-bottom: -20px;
  color: #202020;
}

.timeline-container {
  max-width: 330px;
  margin: auto;
  margin-top:20px;
  position: relative;
}

.timeline-title {
  text-align: center;
  font-family: 'FeelingPassionate';
  font-size: 46px;
  margin-bottom: 40px;
  color: #ffffff;
}

.timeline-title .sub {
  display: block;
  font-size: 20px;
  font-family: serif;
  margin-top: 8px;
  color: #ffffff;
}

.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
  border-left: 3px solid rgb(202, 202, 216);
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
}

.timeline-icon-wrapper {
  display: flex;
  align-items: center;
}

.timeline-line {
  position: absolute;
  top: 0;
  left: -1.5px;
  width: 3px;
  height: 100%;
  background-color: rgb(30, 30, 31);
  z-index: -1;
}

.timeline-star {
  color: #ffffff00;
  font-size: 22px;
  margin-right: 10px;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  min-height: 30px;
}

.timeline-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(80, 77, 77);
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.timeline-time {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 16px;
  color: #ffffff;
  text-align: left;
  margin-left: 15px;
}

.timeline-time .nota {
  font-size: 14px;
  color: #ffffff;
  margin-top: 4px;
  font-style: italic;
}

.timeline-time .evento {
  font-size: 18px;
  color: #eeeeee;
  margin-top: 4px;
  font-style: italic;
}

.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  z-index: 12;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior {
  bottom: 0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
.itinerario-wrapper {
  position: relative;
}
</style>
